import React from "react";
import { DUMMY_STORE_MERCHANTS, type StoreMerchant, type StoreProduct } from "../data/dummyStore";
import type { CartItem } from "../types/store";

type Props = {
  cartCount: number;
  onOpenCart: () => void;
  onAddToCart: (item: Omit<CartItem, "quantity">) => void;
  getItemQuantity: (key: string) => number;
};

function toCartItem(
  merchant: StoreMerchant,
  product: StoreProduct
): Omit<CartItem, "quantity"> {
  return {
    key: `${merchant.id}:${product.id}`,
    merchantName: merchant.paymentMerchantName,
    estiaMerchantId: merchant.estiaMerchantId,
    productName: product.name,
    unitPrice: product.price,
  };
}

const StorePage: React.FC<Props> = ({ cartCount, onOpenCart, onAddToCart, getItemQuantity }) => {
  return (
    <div className="ep-storeShell">
      <header className="ep-storeHeader">
        <h1>Estia Dummy Store</h1>
        <p>Pick any product and continue to QR checkout.</p>
        <button className="ep-cartBtn" onClick={onOpenCart}>
          Cart ({cartCount})
        </button>
      </header>

      <div className="ep-storeGrid">
        {DUMMY_STORE_MERCHANTS.map((merchant) => (
          <section key={merchant.id} className="ep-merchantCard">
            <div className="ep-merchantTop">
              <h2>{merchant.name}</h2>
              <span>{merchant.category}</span>
            </div>

            <div className="ep-products">
              {merchant.products.map((product) => (
                <article key={product.id} className="ep-productCard">
                  <div>
                    <h3>
                      {product.name}
                      {getItemQuantity(`${merchant.id}:${product.id}`) > 0 && (
                        <span className="ep-itemQtyBadge">
                          x{getItemQuantity(`${merchant.id}:${product.id}`)}
                        </span>
                      )}
                    </h3>
                    <p>{product.description}</p>
                  </div>
                  <div className="ep-productMeta">
                    <strong>EUR {product.price.toFixed(2)}</strong>
                    <button onClick={() => onAddToCart(toCartItem(merchant, product))}>
                      Add to cart
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default StorePage;
